export default function SongInfo({ song, revealed }) {
  return (
    <div className="song-info-container">
      <div className="song-info">
        <div className="info-item">
          <label>Song Name</label>
          <p className={revealed.title ? 'revealed' : 'hidden'}>
            {revealed.title ? song?.name : '?????'}
          </p>
        </div>

        <div className="info-item">
          <label>Artist</label>
          <p className={revealed.artist ? 'revealed' : 'hidden'}>
            {revealed.artist ? song?.artists : '?????'}
          </p>
        </div>

        <div className="info-item">
          <label>Year</label>
          <p className={revealed.year ? 'revealed' : 'hidden'}>
            {revealed.year ? song?.year : '????'}
          </p>
        </div>
      </div>
    </div>
  );
}
